import _asyncToGenerator from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/regenerator/index.js";
import { useConfig, useNetwork } from '../providers';
import { useReadonlyNetwork } from './useReadonlyProvider';
/**
 * @public
 */

export function useEthers() {
  var _useNetwork = useNetwork(),
      _useNetwork$network = _useNetwork.network,
      networkProvider = _useNetwork$network.provider,
      chainId = _useNetwork$network.chainId,
      accounts = _useNetwork$network.accounts,
      errors = _useNetwork$network.errors,
      deactivate = _useNetwork.deactivate,
      _activate = _useNetwork.activate,
      activateBrowserWallet = _useNetwork.activateBrowserWallet,
      isLoading = _useNetwork.isLoading;

  var _useConfig = useConfig(),
      networks = _useConfig.networks;

  var supportedChainIds = networks === null || networks === void 0 ? void 0 : networks.map(function (network) {
    return network.chainId;
  });
  var isUnsupportedChainId = chainId && supportedChainIds && supportedChainIds.indexOf(chainId) < 0;
  var unsupportedChainIdError = new Error("Unsupported chain id: ".concat(chainId, ". Supported chain ids are: ").concat(supportedChainIds, "."));
  unsupportedChainIdError.name = 'UnsupportedChainIdError';
  var error = isUnsupportedChainId ? unsupportedChainIdError : errors[errors.length - 1];
  var readonlyNetwork = useReadonlyNetwork();
  var provider = networkProvider !== null && networkProvider !== void 0 ? networkProvider : readonlyNetwork === null || readonlyNetwork === void 0 ? void 0 : readonlyNetwork.provider;
  return {
    connector: undefined,
    library: provider,
    chainId: isUnsupportedChainId ? undefined : networkProvider !== undefined ? chainId : readonlyNetwork === null || readonlyNetwork === void 0 ? void 0 : readonlyNetwork.chainId,
    account: accounts[0],
    active: !!provider,
    activate: function () {
      var _activate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(providerOrConnector) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!('getProvider' in providerOrConnector)) {
                  _context.next = 9;
                  break;
                }

                console.warn('Using web3-react connectors is deprecated and may lead to unexpected behavior.');
                _context.next = 4;
                return providerOrConnector.activate();

              case 4:
                _context.t0 = _activate;
                _context.next = 7;
                return providerOrConnector.getProvider();

              case 7:
                _context.t1 = _context.sent;
                return _context.abrupt("return", (0, _context.t0)(_context.t1));

              case 9:
                return _context.abrupt("return", _activate(providerOrConnector));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function activate(_x) {
        return _activate2.apply(this, arguments);
      }

      return activate;
    }(),
    activateBrowserWallet: activateBrowserWallet,
    deactivate: deactivate,
    setError: function setError() {
      throw new Error('setError is deprecated');
    },
    error: error,
    isLoading: isLoading
  };
}